import React from "react";
import { Facebook, Google } from "@mui/icons-material";
import Style from "./password.module.scss";
import { TextInput } from "../../../components";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { errorMessage, successMessage } from "../../../utils/notification";
import { toast } from "react-toastify";
import { settingContext } from "../../../context/Setting/Setting";
import { useHistory, Link } from "react-router-dom";
import { useQuery } from "../../../utils/query-parameter";
import { Company, Footer, MenuBar } from "../../../layout/welcome";

const Reset = () => {

  const router = useHistory();
  const [isLoading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({});
  const { page, loading } = React.useContext(settingContext);
  const query = useQuery();
  const email = query.get('email');
  const code = query.get('code');

  const handleInputs = (label, e) => {
    var val = e;
    setInput({ ...input, [label]: val });
  };

  React.useEffect(() => {
    setInput({ ...input, ['email']: email, ['code']: code });
  }, [code]);


  const resetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await axios
      .post(process.env.REACT_APP_API_URL + "/auth/set-password", input, {
        "Content-type": "application/json",
      })
      .then((resp) => {
        const { data } = resp;
        setLoading(false);
        successMessage(toast, data.message);
        router.push("/auth/login");
      })
      .catch((error) => {
        const err = error?.response?.data;
        errorMessage(toast, err.message);
        setLoading(false);
      });
  }

  return (
    // <div className={Style.reset}>
    //   <div className={Style.form_section}>
    //     <form className="card p-3">
    //       <div className={Style.logo_section}>
    //         <img className="shadow-inner" src={process.env.REACT_APP_LOCAL_FILE_PATH + 'setting/small/' + page?.setting?.logo} loading="lazy" />
    //         <span className={Style.logoText}>{page?.setting?.app_name}</span>
    //       </div>
    //       <div className="card p-3">
    //         <TextInput
    //           className="shadow"
    //           label="Email Address"
    //           disabled={true}
    //           value={input['email']}
    //           placeholder="Email Address"
    //           type="text"
    //         />
    //         <TextInput
    //           className="shadow"
    //           label="Password"
    //           placeholder="New Password"
    //           type="password"
    //           onChange={(e) => handleInputs("password", e.target.value)}
    //         />
    //         <TextInput
    //           className="shadow"
    //           label="Confirm Password"
    //           placeholder="Confirm Password"
    //           type="password"
    //           onChange={(e) => handleInputs("password_confirmation", e.target.value)}
    //         />
    //         <div className={Style.input_section}>
    //           <button disabled={isLoading}
    //            onClick={resetPassword} 
    //            className={'btn btn-block btn-lg font-weight-bold auth-form-btn l_b_b text-white font-bold shadow-xl'}>
    //             {!isLoading && `Reset Password`}
    //             {isLoading && (
    //               <div className={Style.progressContainer}>
    //                 <CircularProgress
    //                   size={15}
    //                   sx={{ color: "white", marginRight: 2 }}
    //                 />
    //                 <p>Connecting</p>
    //               </div>
    //             )}
    //           </button>
    //         </div>
    //         <div className={Style.input_section}>
    //           <span className={Style.sigup}>
    //             Already have an account yet?{" "}
    //             <Link to={"/auth/login"}>Sign In</Link>
    //           </span>
    //         </div>
    //       </div>
    //       {/* <Company card={true} /> */}
    //     </form>
    //   </div>
    //   <div className={Style.image_section}>
    //     {page?.login_image && <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + page?.reset_image?.image} loading="lazy" />}
    //     {/* <img src="/img/learn.png" loading="lazy" /> */}
    //   </div>
    // </div>

    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar menuIndex="auth" setting={page?.setting} loader={loading} />
        <section id="login-content" className="login-content" >
          <div className="awe-parallax bg-login-content" style={{ backgroundImage: 'url(../img/bg.jpg)' }}></div>
          <div className="awe-overlay" />
          <div className="container">
            <div className="">
              {/* FORM */}
              <div className="md:float-right">
                <div className="form-login">
                  <form>
                    <h2 className="text-uppercase">Set New Password</h2>
                    <div className="form-email">
                      <input
                        type="text"
                        value={input['email']}
                        onChange={(e) => handleInputs("email", e.target.value)}
                        className="l_r_b"
                        placeholder="Email"
                      />
                    </div>
                    <div className="form-password">
                      <input
                        onChange={(e) => handleInputs("password", e.target.value)}
                        type="password"
                        placeholder="Password" />
                    </div>
                    <div className="form-password">
                      <input
                        onChange={(e) => handleInputs("password_confirmation", e.target.value)}
                        type="password"
                        placeholder="Password" />
                    </div>
                   
                    <div className="form-submit-1">
                      <button
                        disabled={isLoading}
                        onClick={resetPassword}
                        type="submit"
                        defaultValue="Sign In"
                        className="mc-btn btn-style-1" >
                        {!isLoading && `Submit`}
                        {isLoading && (
                          <div className="d-flex flex-row align-center">
                            <CircularProgress
                              size={15}
                              sx={{ color: "white", marginRight: 2 }}
                            />
                            <p>Connecting</p>
                          </div>
                        )}
                      </button>
                    </div>
                    <div className="link">
                      <Link to={"/auth/login"}>
                        <i className="icon fa-solid fa-circle-arrow-right" />Already have an account yet? ? Sign In
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              {/* END / FORM */}
              <div className="image auth-image">
                <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + page?.page_slide?.image} alt="" />
              </div>
            </div>
          </div>
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
};

export default Reset;
